import { TableContainer } from '@mui/material';
import { DataGrid as MuiDataGrid } from '@mui/x-data-grid';
import styled, { css } from 'styled-components';

import Doppler from 'components/Doppler';

const TotalTableValue = styled.span`
  ${({ theme }) => css`
    color: ${theme.palette.secondary.main};

    ${theme.breakpoints.up('sm')} {
      color: ${theme.palette.dark.main};
    }
  `}
`;

const TotalTableLabel = styled.span`
  text-transform: uppercase;

  ${({ theme }) => css`
    color: ${theme.palette.dark.main};
    font-size: 0.75rem;
    font-family: ${theme.typography.fontFamilyAccent};

    ${theme.breakpoints.up('sm')} {
      font-size: 1rem;
      font-family: ${theme.typography.fontFamily};
    }
  `}
`;

const TotalTableCell = styled(Doppler)`
  ${({ theme }) =>
    css`
      color: ${theme.palette.dark.main};
      font-weight: bold;

      &.MuiDataGrid-cell-totalLabel {
        font-weight: 400;
        text-transform: none;
        font-family: ${theme.typography.fontFamily};
        font-size: 0.875rem;

        ${theme.breakpoints.up('sm')} {
          font-size: 1rem;
        }

        ${theme.breakpoints.up('md')} {
          padding-left: 30px;
          border-left: 10px solid ${theme.palette.dark.main};
        }
      }
    `}
`;

export default {
  DataGrid: styled(MuiDataGrid)``,

  TotalBlock: styled(TableContainer)`
    position: relative;
    padding: 16px 20px;
    margin-top: 20px;

    & .MuiDataGrid-row:hover {
      background-color: transparent;
    }

    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        padding: 0;
        border-radius: 0;
      }
    `}
  `,

  TotalTableCell,

  TotalRow: styled(Doppler)`
    display: flex;
    align-items: center;
    padding: 6px 0;
    justify-content: space-between;
    border-bottom: 1px solid #f5f8fb;
    font-weight: 700;

    &:first-child,
    &:last-child {
      border-bottom-width: 0;
    }

    ${({ $simple, theme }) =>
      $simple &&
      css`
        margin-bottom: 0.5rem;

        ${TotalTableLabel} {
          margin-right: 20px;
          font-weight: 400;
          text-transform: none;
          font-family: ${theme.typography.fontFamily};
          font-size: 0.875rem;

          ${theme.breakpoints.up('sm')} {
            font-size: 1rem;
          }
        }
      `}
  `,

  TotalTableLabel,
  TotalTableValue,
};
